<template>
    <module-card>
        <p class="text-h6 text-center">My BottomLine</p>
        <div class="bottom-line">
            <div v-for="statement in bottomLineStatements" :key="statement.id">
                <label class="bottomline-statement" v-html="statement.statement"></label>
                <label class="bottomline-response">{{ bottomLine(statement.id) }}</label>
            </div>
        </div>
    </module-card>
</template>

<script>
    import { get } from 'vuex-pathify';

    export default {
        methods: {
            bottomLine(id) {
                // bottomline for the current module, should be complete.
                return this.bottomLineChoices[this.myBottomLine[id].response].choice;
            }
        },
        computed: {
            myBottomLine() {
                return this.$store.get(`bottomLine@${this.$route.params.module}.myBottomLine`);
            },
            bottomLineStatements: get('content@bottomLineStatements'),
            bottomLineChoices: get('content@bottomLineChoices')
        }
    };
</script>

<style scoped>
    .bottom-line {
        width: 100%;
        background-color: var(--v-primary-base);
        padding: 5px;
    }
    .bottomline-statement {
        color: white;
        display: block;
        padding: 5px;
        width: 100%;
    }
    .bottomline-response {
        background-color: white;
        display: block;
        width: 100%;
        padding-left: 5px;
    }
</style>
